var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.colorOptions),function(color){return _c('Button',{key:color.id,staticClass:"p-mr-2",class:{
      'white-text': _vm.isDark(color.code),
      'transparent-text': _vm.value !== color.code
    },style:('background-color: #' + color.code),attrs:{"icon":"pi pi-check"},on:{"click":function($event){return _vm.setSelectedColor(color.code)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }